var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('NavigationDrawer'),_c('v-col',{staticClass:"wrap"},[_c('Card')],1),_c('div',{staticClass:"wrap"},[_c('ExclusiveServicesCarousel')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }